import React from "react";

export const Spinner = ({ color, size }) => {
  return (
    <p className={`${size ? size : "max-w-4xl"} mx-auto text-center`}>
      <i
        className={`fa fa-spinner fa-spin text-4xl ${
          color ? color : "text-gray-600"
        }`}
      ></i>
    </p>
  );
};

export default Spinner;
